import React from "react";
import { Helmet } from "react-helmet-async";
import { BRAND, siteUrl } from "../utils/config";

export const DEFAULT_TITLE = "Ratan Market | Satta Matka Result Today, Live Matka Chart";
export const DEFAULT_DESCRIPTION =
  "Satta matka result today on Ratan Market — live Kalyan, Milan, Madhur, Sridevi, Main Bazar and Rajdhani results with Jodi and Panel (Pana) charts and market timings.";
const DEFAULT_KEYWORDS =
  "satta matka, satta matka result, matka result today, matka result, kalyan matka, kalyan chart, kalyan panel chart, kalyan jodi chart, main bazar chart, milan day chart, madhur day chart, matka chart, matka jodi chart, matka panel chart, ratan khatri, ratan market, matka app";

// One place for <head>: title, description, canonical, Open Graph, Twitter and JSON-LD.
const Seo = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  path = "/",
  image = "/og-image.png",
  type = "website",
  noIndex = false,
  schema = [],
}) => {
  const origin = siteUrl();
  const url = `${origin}${path}`;
  const img = image.startsWith("http") ? image : `${origin}${image}`;
  const robots = noIndex
    ? "noindex, nofollow"
    : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";

  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${origin}/#organization`,
        name: BRAND.name,
        url: origin,
        logo: { "@type": "ImageObject", url: `${origin}/icon-512.png`, width: 512, height: 512 },
      },
      {
        "@type": "WebSite",
        "@id": `${origin}/#website`,
        url: `${origin}/`,
        name: BRAND.name,
        inLanguage: "en-IN",
        publisher: { "@id": `${origin}/#organization` },
      },
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        url,
        name: title,
        description,
        inLanguage: "en-IN",
        isPartOf: { "@id": `${origin}/#website` },
        primaryImageOfPage: { "@type": "ImageObject", url: img },
      },
    ],
  };

  return (
    <Helmet>
      <html lang="en-IN" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="en-IN" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={BRAND.name} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      <script type="application/ld+json">{JSON.stringify(graph)}</script>
      {schema.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
